import React, { useState, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import FormOpportunitiesTable from './FormOpportunitiesTable';
import CallsOpportunitiesTable from './CallsOpportunitiesTable';
import { storeContext } from '../provider/Provider';
import useStyles from './Opportunities.style';

const Opportunities = () => {
  const classes = useStyles();
  const { state } = useContext(storeContext);
  let isPhone = false;
  const location = useLocation();
  const data = location.state?.source

  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }

  const [source, setSource] = useState(data || 'form');

  return (
    <div className={isPhone ? '' : classes.wrapper}>
      <div className={isPhone ? '' : classes.card}>
        <div className={isPhone ? '' : classes.card__wrapper}>
          <div style={{ 
            display: source === 'form' ? 'block' : 'none',
            minHeight: '90vh',
          }}>
            <FormOpportunitiesTable handleSourceChange={setSource} />
          </div>
          <div style={{ 
            display: source === 'calls' ? 'block' : 'none',
            minHeight: '90vh',
          }}>
            <CallsOpportunitiesTable handleSourceChange={setSource} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opportunities;
